module.exports = __webpack_public_path__ + "static/media/lea_cornelius_carstens.34d5582.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/lea/lea_cornelius_carstens.mp3
// module id = tsCT
// module chunks = 1